const config = {
  apiUrl: 'https://api-prod.skillcraft.app',
  insiderBuild: true,
  alternativeGameFlow: true,
};

export default config;
